module.exports = __webpack_public_path__ + "img/game01.77036775.png";